import type { SummarySectionConfig } from 'features/traffic/campaigns/campaign-configs/types';
import { getPlacementDisplayNameNoPlatform as getPlacementDisplayName } from '../../utils/get-placement-display-name';
import type {
  FeaturedBrandsContent,
  FeaturedBrandsGlobalContent,
  FeaturedBrandsOverviewTableData,
  FeaturedBrandsPlacementTableRowData,
} from '../types';
import { ContentTableContent } from './components/ContentTableContent';
import { KeywordsSummaryTableRow } from './components/KeywordsSummaryTableRow';
import { getContentTableData } from './get-content-table-data';
import { getOverviewTableData } from './get-overview-table-data';
import { getPlacementTableRowData } from './get-placement-table-row-data';

export const summarySectionConfig: SummarySectionConfig<
  FeaturedBrandsOverviewTableData,
  FeaturedBrandsContent,
  FeaturedBrandsPlacementTableRowData,
  FeaturedBrandsGlobalContent
> = {
  ContentTableContent,
  GenericPlacementSummaryTableRow: KeywordsSummaryTableRow,
  getContentTableData,
  getOverviewTableData,
  getPlacementDisplayName,
  getPlacementTableRowData,
};
